// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eff89eab","455":"ffeeb9f1","488":"4e79fee0","977":"e0528a0a"}[chunkId] + ".chunk.js";
};